import axios from "axios";
import Blogs from "./Blogs";
import "../assets/home_trek.png";
import "../assets/newsLetter.png";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import "../assets/home/testimonialBg.png";
import { NavLink } from "react-router-dom";
import Layouts from "../components/UI/Layouts";
import { useLocation } from "react-router-dom";
import user1 from "../assets/dummy_user1.webp";
import user2 from "../assets/dummy_user2.webp";
import user3 from "../assets/dummy_user3.jpeg";
import user4 from "../assets/dummy_user4.webp";
import { useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Button from "../components/common/Button";
import HomeCard from "../components/home/HomeCard";
import MetaTags from "../components/meta/MetaTags";
import { useDispatch, useSelector } from "react-redux";
import VideoModal from "../components/home/VideoModal";
import { ButtonAlt } from "../components/common/Button";
import { useState, useRef, useEffect, useCallback } from "react";
import HomeTestimonial from "../components/home/HomeTestimonial";
import { FaChevronCircleRight, FaChevronCircleLeft } from "react-icons/fa";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Scrollbar, Navigation, Pagination, Autoplay } from "swiper";
import { setAllBanners, setAllBlogs } from "../store/slices/activitiesSlice";

const Home = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { hash } = useLocation();
  const [on1, setOn1] = useState(true);
  const navigationNextRef1 = useRef(null);
  const navigationPrevRef1 = useRef(null);
  const banner = useSelector((state) => state.activities?.allBanners);
  const blogs = useSelector((state) => state.activities?.allBlogs);
  const [showVideoModal, setShowVideoModal] = useState({ project: false, video_url: "" });
  const activities = useSelector((state) => state.activities?.activities);
  const combos = useSelector((state) => state.activities?.combos);
  const count = useSelector((state) => state.cart?.items);

  useEffect(() => {
    const handleScroll = () => {
      if (location.hash.includes("#")) {
        const element = document.getElementById(hash.slice(1));
        setTimeout(() => {
          window.scrollTo({
            behavior: "smooth",
            top: element ? element.offsetTop : 0,
          });
          navigate("/");
        }, 100);
      }
    };
    handleScroll();
  }, [hash, location, navigate]);

  const fetchBannerImages = useCallback(async () => {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}public/api/banner`);
    const filteredImages = resp.data.banner.filter((e) => !e.image_url.includes(".mp4", ".mkv"));
    filteredImages.push(...resp.data.banner.filter((e) => e.image_url.includes(".mp4", ".mkv")));
    dispatch(setAllBanners(filteredImages));
  }, [dispatch]);

  const fetchBlogs = useCallback(async () => {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}public/v2/api/blog`);
    dispatch(setAllBlogs(resp.data.result));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    if (banner.length < 1) {
      fetchBannerImages();
    }
    if (blogs.length < 1) {
      fetchBlogs();
    }
  }, [dispatch, fetchBannerImages, fetchBlogs, banner, blogs]);

  return (
    <Layouts transparent={true}>
      <MetaTags metaDesc={data?.metaDesc} metaTitle={data?.metaTitle} metaKey={data?.metaKeyword} />
      <div className="w-full min-h-full flex items-center justify-center scroll-smooth">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="w-full top-0 left-0"
        >
          {banner.length > 1 ? (
            <Swiper
              initialSlide={1}
              slidesPerView={1}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              slidesPerGroupSkip={1}
              loop={true}
              pagination={{ clickable: true }}
              modules={[Scrollbar, Navigation, Pagination, Autoplay]}
            >
              {banner.map((home) => (
                // <SwiperSlide key={home._id}>
                //   <div className="w-full max-h-full lg:h-screen">
                //     <img
                //       src={home.image_url}
                //       alt="home"
                //       className="w-full h-full object-contain lg:object-cover"
                //     />
                //   </div>
                //  <div
                //   className="w-full h-96 text-white-900 z-10 pt-44 md:mb-2 md:pt-36 lg:pt-72 xl:pt-80 lg:h-screen pb-20"
                //   style={{
                //     backgroundImage: `url(${home.image_url})`,
                //     backgroundPosition: "center",
                //     backgroundRepeat: "no-repeat",
                //     backgroundSize: "contain",
                //   }}
                // >
                //                   <div className="w-fit mx-auto select-none">
                //     <h2 className="text-3xl sm:text-4xl text-center mb-4 md:mb-0 md:text-left font-black lg:text-5xl xl:text-6xl ml-6">
                //       {home.subheading}
                //     </h2>
                //     <h1 className="text-4xl sm:text-6xl text-center uppercase md:text-left lg:text-8xl xl:text-9xl text-transparent font-bold tracking-wider custom-stroke">
                //       {home.heading}
                //     </h1>
                //     <div className="flex justify-center mt-6 md:mt-10 lg:mt-12 ">
                //       <a href="#explore">
                //         <Button
                //           text="EXPLORE NOW"
                //           className="py-2 px-6 text-base md:py-3 md:px-10 tracking-wider md:text-xl"
                //         />
                //       </a>
                //     </div>
                //   </div>
                //  </div>
                <SwiperSlide key={home._id}>
                  <div className="w-full max-h-full">
                    {!home.image_url.includes(".mp4") ? (
                      <img
                        src={home.image_url}
                        alt="home"
                        loading="lazy"
                        className="w-full h-full object-contain lg:object-cover"
                      />
                    ) : (
                      <video
                        src={home.image_url}
                        autoPlay
                        loop
                        muted
                        className="w-full h-full object-contain lg:object-cover"
                      ></video>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="w-full max-h-full">
              {!banner[0]?.image_url.includes(".mp4") ? (
                <img
                  src={banner[0]?.image_url}
                  alt="home"
                  loading="lazy"
                  className="w-full h-full object-contain lg:object-cover"
                />
              ) : (
                <video
                  src={banner[0]?.image_url}
                  autoPlay
                  loop
                  muted
                  className="w-full h-full object-contain lg:object-cover"
                ></video>
              )}
            </div>
          )}
        </motion.div>
      </div>
      <div className="max-w-screen-2xl mx-auto">
        <div className="section-extra">
          <div className="text-center mb-4" id="allActivities">
            <h2 className="text-4xl md:text-6xl font-bold my-6 md:my-12 text-primary">
              All Activities
            </h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mx-5 lg:mx-8"
          >
            {activities?.map(
              (e) =>
                e?.status && (
                  <HomeCard
                    id={e._id}
                    key={e._id}
                    slug={e.slug}
                    name={e.name}
                    image={e.imageUrl}
                    status={e?.status}
                    body={
                      e?.info
                        ? e.info.length > 100
                          ? `${e?.info.substr(0, 100)}...`
                          : e.info
                        : e.description.length > 100
                        ? `${e.description.substr(0, 100)}...`
                        : e.description
                    }
                    location={e.location}
                    person={e?.noOfPerson}
                    youtubeUrl={e?.youtubeUrl}
                    variants={e?.variant}
                    videoThumbnails={e?.videoThumbnail}
                    price={e.price}
                    showVideoModal={showVideoModal}
                    setShowVideoModal={setShowVideoModal}
                  />
                ),
            )}
          </motion.div>
          <div className="text-center mb-4" id="allCombos">
            <h2 className="text-3xl md:text-6xl font-bold my-6 md:my-12 text-primary">
              Choose Combo To Save Money
            </h2>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mx-5 lg:mx-8"
          >
            {combos?.map(
              (e, index) =>
                e?.status && (
                  <HomeCard
                    id={e._id}
                    key={e._id}
                    name={e.name}
                    slug={e.slug}
                    image={e.imageUrl}
                    status={e?.status}
                    body={
                      e?.info
                        ? e.info.length > 100
                          ? `${e?.info.substr(0, 100)}...`
                          : e.info
                        : e.description.length > 100
                        ? `${e.description.substr(0, 100)}...`
                        : e.description
                    }
                    location={e.location}
                    person={e?.noOfPerson}
                    variants={e?.variant}
                    youtubeUrl={e?.youtubeUrl}
                    activities={e?.activities}
                    videoThumbnails={e?.videoThumbnail}
                    showVideoModal={showVideoModal}
                    price={e.price}
                    setShowVideoModal={setShowVideoModal}
                  />
                ),
            )}
          </motion.div>
        </div>
      </div>
      <AnimatePresence onExitComplete={() => null} initial={false}>
        {showVideoModal.project && (
          <VideoModal showVideoModal={showVideoModal} setShowVideoModal={setShowVideoModal} />
        )}
      </AnimatePresence>
      <div
        className="flex justify-center mx-auto mt-20 mb-0 md:mb-10 lg:mb-20"
        onClick={() => {
          if (count.length < 1) toast.warn("Your Cart is Empty");
          else navigate("/cart");
        }}
      >
        <Button text="Book Now" className="text-4xl font-bold px-8 py-2" />
      </div>
      <div className="max-w-screen-2xl mx-auto setion-5 px-4 md:px-6 lg:px-8 xl:px-10 my-16 lg:my-32 w-full lg:bg-[url('assets/home/testimonialBg.png')] lg:bg-no-repeat lg:bg-contain ">
        <div className="text-center relative mb-4 md:mb-16">
          <h2 className="text-xl md:text-3xl font-bold mb-3"> What People Say</h2>
          <p className="text-md md:text-lg md-p-0 p-4 pt-0 text-gray-400 lg:font-medium">
            Our customers send us a bunch of smiles with our service
            <span className="md:block"> and we love them.</span>
          </p>
          <p className="text-md md:text-lg text-gray-400 font-medium"></p>
          <div className="flex justify-center my-8 items-end md:px-10 md:gap-20 lg:px-28 xl:px-44 flex-wrap-reverse lg:flex-nowrap ">
            <span onClick={() => setOn1(false)} ref={navigationPrevRef1} className="md:mb-12">
              <FaChevronCircleLeft
                className={
                  on1
                    ? "text-3xl text-gray-400 hover:cursor-pointer"
                    : "text-3xl text-primary hover:cursor-pointer"
                }
              />
            </span>
            <Swiper
              slidesPerView={1}
              centeredSlides={true}
              slidesPerGroupSkip={1}
              spaceBetween={40}
              freeMode={true}
              grabCursor={true}
              navigation={{
                prevEl: navigationPrevRef1.current ? navigationPrevRef1.current : null,
                nextEl: navigationNextRef1.current ? navigationNextRef1.current : null,
              }}
              observeParents={true}
              observer={true}
              modules={[Scrollbar, Navigation, Pagination, Autoplay]}
              onInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef1.current;
                swiper.params.navigation.nextEl = navigationNextRef1.current;
                swiper.navigation.update();
              }}
              className="order-2 lg:order-none"
            >
              <SwiperSlide key={1}>
                <HomeTestimonial
                  userImg={user1}
                  name="Raghav Meena"
                  location="New Delhi, Delhi"
                  description="I wanted to thank you for the amazing adventure you created. It was the most unique trip and we will cherish it forever! Thank you "
                />
              </SwiperSlide>
              <SwiperSlide key={2}>
                <HomeTestimonial
                  userImg={user2}
                  name="Sunita Gupta"
                  location="Noida"
                  description="First let us thank you! This adventure has been amazing, enjoyed a lot."
                />
              </SwiperSlide>
              <SwiperSlide key={3}>
                <HomeTestimonial
                  userImg={user3}
                  name="Yogender Yadav"
                  location="Jaipur, Rajasthan"
                  description="Even now I’m still remembering the experience with great joy. Cannot wait for my calendar to line up to do another adventures in Rishikesh soon."
                />
              </SwiperSlide>
              <SwiperSlide>
                <HomeTestimonial
                  userImg={user4}
                  name="Sanjay Dudeja"
                  location="New Delhi, Delhi"
                  description="Just to let you know that we had a fabulous time in Rishikesh! Excellent people and excellent activities! I guess I didn't really know what to expect from Rishikesh - but it surpassed any expectations I had many times over."
                />
              </SwiperSlide>
            </Swiper>
            <span
              onClick={() => setOn1(true)}
              ref={navigationNextRef1}
              className="ml-4 md:ml-0 md:mb-12"
            >
              <FaChevronCircleRight
                className={
                  on1
                    ? "text-3xl text-primary hover:cursor-pointer"
                    : "text-3xl text-gray-400 hover:cursor-pointer"
                }
              />
            </span>
          </div>
        </div>
      </div>
      <div className="text-center lg:mb-4 flex justify-between items-center lg:block mx-8">
        <h2 className="text-xl md:text-6xl font-bold my-6 md:my-12 text-primary">Our Blogs</h2>
        <NavLink to="/blogs/all" className="lg:hidden">
          <p className="text-primary text-base md:text-3xl">See All</p>
        </NavLink>
      </div>
      <div className="max-w-screen-2xl mx-auto">
        <Blogs blogs={blogs} />
      </div>
      {blogs.length > 5 ? (
        <div className="hidden lg:block lg:w-full lg:text-center lg:mt-8">
          <NavLink to="/blogs/all">
            <ButtonAlt text="See All" className="py-2 w-48 font-medium" />
          </NavLink>
        </div>
      ) : null}
      {/* <div className="m-8 text-justify hidden">
         <p>Discover the greatest experience of bungee jumping in Rishikesh. Surrounded by the  picturesque hill ranges of Rishikesh, a charming city that combines the roots of divine spirituality with thrilling adventure sports. Thrill Factory is your only stop for thrilling adventures such as reverse bungee, nightlife, bag jump & the most adventurous bungee jumping in Rishikesh.</p>
         <p>There are many known places for adventure experience in India but the most popular spot is bungee jumping in Rishikesh. Thrill factory makes sure that the concept of bungee jumping in Rishikesh never loses its captivating spirit and follows every safety protocol under the observation of a professional. When you do bungee jumping in Rishikesh, you are expected to get attached to a safety cord from a great height. If you want to make memories of a lifetime then bungee jumping in Rishikesh at Thrill Factory is the perfect adventure sport for you. Apart from bungee jumping in Rishikesh, Thrill Factory also offers other adventure activities such as giant swing, zip lining, reverse bungee & sky cycling.</p>
      </div> */}
    </Layouts>
  );
};

export default Home;
